import Component from 'vue-class-component';
import { Checkbox } from 'streamlabs-beaker';
import { Prop, Watch } from 'vue-property-decorator';
import Base from '../Base';

@Component({
  components: {
    SCheckbox: Checkbox,
  },
})
export default class DisclaimerCheckbox extends Base {
  @Prop({ required: false, default: 'checkout' })
  componentName: string;

  get hasAgreedTooTermsTooltipProperties() {
    return {
      content: 'Please check this box if you want to proceed',
      trigger: 'manual',
      show: this.displayAgreeToTermsError,
      classes: `disclaimer__checkbox-tooltip--${this.componentName}`,
      offset: 12,
    };
  }

  toggleHasAgreedToTerms() {
    this.hasAgreedToTerms = !this.hasAgreedToTerms;
  }

  @Watch('hasAgreedToTerms')
  handler() {
    if (this.hasAgreedToTerms) this.displayAgreeToTermsError = false;
  }
}
